module.exports = require("./objectWithoutProperties.js");


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-scripts/node_modules/babel-runtime/helpers/object-without-properties.js
// module id = 21
// module chunks = 0